export const addressQueryParamSeparator = ';';
export const addressQueryParamKey = 'address';
export const relationshipQueryParamKey = 'relationship';
export const annualStatementsQueryParamKey = 'annualId';
export const documentsQueryParamKey = 'documentId';
